import { Play } from "lucide-react";

export const HumStartButton = ({ onStart }) => (
  <button className="hum-start" onClick={onStart} data-testid="hum-start-button" aria-label="Start the hum">
    <span className="hum-start-ring" />
    <Play className="hum-start-icon" size={64} fill="currentColor" />
    <span className="hum-start-label">tap to start the hum</span>
  </button>
);
